export const EQUIPOS = ['SAT_0_1', 'SAT_0_2', 'SAT_0_3'];
